import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { SERVICES } from "@/lib/content";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="container-arms grid gap-12 py-16 lg:py-20 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-5">
          <Logo light={false} full className="!h-16 sm:!h-20" />
          <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
            Changing attitudes, behaviour and culture in complex organisations.
          </p>
        </div>
        <nav aria-label="Footer pages">
          <h3 className="eyebrow mb-5">Explore</h3>
          <ul className="space-y-3 text-sm">
            {[["About Us", "/about"], ["Our Services", "/services"], ["Our Approach", "/approach"], ["Case Studies", "/case-studies"], ["Insights", "/insights"], ["Contact Us", "/contact"]].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-slate-500 transition-colors hover:text-teal">{label}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Footer services">
          <h3 className="eyebrow mb-5">Services</h3>
          <ul className="space-y-3 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to={`/services#${s.id}`} className="text-slate-500 transition-colors hover:text-teal">{s.title}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <h3 className="eyebrow mb-5">Start a conversation</h3>
          <p className="text-sm text-slate-500 leading-relaxed mb-3 flex items-start gap-2.5">
            <Phone size={16} className="mt-0.5 shrink-0 text-teal" aria-hidden="true" />
            <span>Tell us about your organisation and the culture you want to build.</span>
          </p>
          <p className="text-sm text-slate-500 leading-relaxed mb-5 flex items-start gap-2.5">
            <Mail size={16} className="mt-0.5 shrink-0 text-teal" aria-hidden="true" />
            <span>If you'd rather keep things even simpler just ask us to reply by email and then you can decide if it's worth having a follow up call</span>
          </p>
          <Link
            to="/contact#enquiry-form"
            data-testid="footer-enquire-cta"
            className="inline-block rounded-full bg-teal px-6 py-3 text-sm font-bold text-white transition-all duration-200 hover:scale-[1.03] hover:bg-navy"
          >
            Make an enquiry
          </Link>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="container-arms flex flex-col sm:flex-row items-center justify-between gap-3 py-6 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Advanced Risk Management Solutions Ltd. All rights reserved.</p>
          <p>Changing attitudes, behaviour and culture.</p>
        </div>
      </div>
    </footer>
  );
}
